import { Valor } from '@/componentes/valor';
import type { ArquivoAdmin } from '@/dados';

import { Capitulo, NaoPreenchido } from './ficha';

/* O que a empresa arquivou: análises salvas no histórico e laudos gerados.
 *
 * Só a data. O conteúdo de cada uma é a fotografia dos números daquele dia, e
 * ler o preço de um cliente não é o que o painel existe para fazer. */

function Datas({ itens, vazio }: { itens: ArquivoAdmin[]; vazio: string }) {
  if (itens.length === 0) return <NaoPreenchido>{vazio}</NaoPreenchido>;
  return (
    <ul className="grid gap-1">
      {itens.map((item) => (
        <li key={item.id}>
          <Valor valor={item.criado_em} formato="data" tamanho="apoio" />
        </li>
      ))}
    </ul>
  );
}

export function Analises({
  orcamentos,
  diagnosticos,
}: {
  orcamentos: ArquivoAdmin[];
  diagnosticos: ArquivoAdmin[];
}) {
  return (
    <>
      <Capitulo titulo="Análises salvas" descricao="O histórico de orçamentos.">
        <Datas itens={orcamentos} vazio="Nenhuma análise salva." />
      </Capitulo>
      <Capitulo titulo="Laudos gerados" descricao="Cada visita ao relatório se arquiva sozinha.">
        <Datas itens={diagnosticos} vazio="Nenhum laudo gerado." />
      </Capitulo>
    </>
  );
}
